import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from 'react-router-dom';
import HomePage from './components/pages/homePage';
import Contact from './components/pages/contact';
import Rules from './components/pages/rules';
import Privacy from './components/pages/privacy';
import Terms from './components/pages/terms';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
            <Route name="home" exact path="/" component={HomePage} />
            <Route name="contact" exact path="/contact" component={Contact} />
            <Route name="rules" exact path="/rules" component={Rules} />
            <Route name="terms" exact path="/terms" component={Terms} />
            <Route name="privacy" exact path="/privacy" component={Privacy} />
        </div>
      </Router>
    )
  }
}

export default App;